import { INBOX_TYPES, TWILIO_CHANNEL_MEDIUM } from 'dashboard/helper/inbox';
import { MESSAGE_STATUS, MESSAGE_TYPE } from 'shared/constants/messages';

export const CUSTOMER_RECEIPT_STATUS = Object.freeze({
  READ: 'read',
  UNREAD: 'unread',
  FAILED: 'failed',
  PROGRESS: 'progress',
  HIDDEN: 'hidden',
});

const RECEIPT_SUPPORTED_CHANNELS = [
  INBOX_TYPES.WEB,
  INBOX_TYPES.FB,
  INBOX_TYPES.WHATSAPP,
  INBOX_TYPES.API,
  INBOX_TYPES.TELEGRAM,
  INBOX_TYPES.TELEGRAM_USER,
  INBOX_TYPES.INSTAGRAM,
  INBOX_TYPES.TIKTOK,
];

const readValue = (resource, camelKey, snakeKey = camelKey) => {
  return resource?.[camelKey] ?? resource?.[snakeKey];
};

const isDeletedMessage = message => {
  const contentAttributes =
    readValue(message, 'contentAttributes', 'content_attributes') || {};

  return contentAttributes.deleted === true;
};

const isPublicOutgoingMessage = message => {
  const messageType = readValue(message, 'messageType', 'message_type');
  const isPrivate = readValue(message, 'private');

  return (
    !isPrivate &&
    [MESSAGE_TYPE.OUTGOING, MESSAGE_TYPE.TEMPLATE].includes(messageType)
  );
};

export const supportsCustomerReceiptStatus = inbox => {
  const channelType = readValue(inbox, 'channelType', 'channel_type');
  const medium = readValue(inbox, 'medium');

  if (RECEIPT_SUPPORTED_CHANNELS.includes(channelType)) {
    return true;
  }

  return (
    channelType === INBOX_TYPES.TWILIO &&
    medium === TWILIO_CHANNEL_MEDIUM.WHATSAPP
  );
};

export const getCustomerReceiptStatus = (message, inbox) => {
  if (
    !message ||
    !isPublicOutgoingMessage(message) ||
    isDeletedMessage(message)
  ) {
    return CUSTOMER_RECEIPT_STATUS.HIDDEN;
  }

  const status = readValue(message, 'status');

  if (status === MESSAGE_STATUS.FAILED) {
    return CUSTOMER_RECEIPT_STATUS.FAILED;
  }

  const supportsReceiptStatus = supportsCustomerReceiptStatus(inbox);

  if (status === MESSAGE_STATUS.PROGRESS) {
    return supportsReceiptStatus
      ? CUSTOMER_RECEIPT_STATUS.PROGRESS
      : CUSTOMER_RECEIPT_STATUS.HIDDEN;
  }

  if (!supportsReceiptStatus) {
    return CUSTOMER_RECEIPT_STATUS.HIDDEN;
  }

  if (status === MESSAGE_STATUS.READ) {
    return CUSTOMER_RECEIPT_STATUS.READ;
  }

  if ([MESSAGE_STATUS.SENT, MESSAGE_STATUS.DELIVERED].includes(status)) {
    return CUSTOMER_RECEIPT_STATUS.UNREAD;
  }

  return CUSTOMER_RECEIPT_STATUS.HIDDEN;
};
